import regeneratorRuntime from "regenerator-runtime";

class UserContextMenuInvoker {
  constructor(phxComponent){
    this._phxComponent = phxComponent
    this._init()
  }

  _init(){
    this.getComponents().then( (tippy) => {
      let randomId = this._phxComponent.el.dataset.randomId
      let targetSelector = `[phx-click=open_user_context_menu][phx-value-target_id=${randomId}]`
      let target = document.querySelector(targetSelector)
      let template = this._phxComponent.el.querySelector('[js-id=user-context-menu]')
      let meSelector = `[data-random-id=${randomId}]`
      const instance = tippy(target, {
        content: template.innerHTML,
        allowHTML: true,
        placement: 'top-start',
        trigger: 'manual',
        animation: 'perspective',
        interactive: true,
        arrow: true,
        offset: [0, 0],
        zIndex: 40,
        onHide: () => {
          this._phxComponent.pushEvent('close_user_context_menu', {})
        },
      });

      instance.show()

      this._phxComponent.handleEvent("set_tippy_hide_on_click", (data) => {
        this._tippyInstance.setProps({
          hideOnClick: data.enabled
        })
      })

      let notesDiv = instance.popper.querySelector('[js-id=user-notes-editor]')
      if (notesDiv) {
        notesDiv.addEventListener('input', () =>
          this._saveNoteButton.classList.remove('hidden')
        )
        this._notesDiv = notesDiv

        let saveNoteButton = instance.popper.querySelector('[js-id=save-note]')
        saveNoteButton.addEventListener('click', () => {
          let params = {
            content: this._notesDiv.innerText,
            user_id: this._notesDiv.dataset.userId
          }
          this._phxComponent.pushEventTo(meSelector, "save_note", params, () => {
            this._saveNoteButton.classList.add('hidden')
          })
        })
        this._saveNoteButton = saveNoteButton;
        this._saveNoteButton.classList.add('hidden')
      }

      this._tippyInstance = instance;
    })
  }

  async getComponents() {
    const {default: tippy} = await import('tippy.js')
    await import('tippy.js/dist/tippy.css')
    //await import('tippy.js/animations/shift-away-subtle.css')
    await import('tippy.js/animations/perspective.css')
    //await import('tippy.js/dist/backdrop.css')
    //await import('tippy.js/animations/shift-away.css')
    return tippy
  }
}

const UserContextMenu = {
  mounted(){
    this.userContextMenu = new UserContextMenuInvoker(this)
    console.log('UserContextMenu mounted')
  },
  disconnected() {
    console.log('UserContextMenu disconnected')
  },
  reconnected()  { console.log('UserContextMenu reconnected') },
  updated()      { console.log('UserContextMenu updated') },
  destroyed()    {
    if (this.userContextMenu._tippyInstance)
      this.userContextMenu._tippyInstance.destroy()
    console.log('UserContextMenu destroyed')
  }
}

export default { UserContextMenu };
